<template>
  <div>
    <!-- <div v-bind:style="{position: 'fixed', top: '0px', left: '0px', width: '100%', height: `${getBannerSize()[1]}px`, 'background-color': '#3458A4', 'z-index': 1030, cursor: 'pointer'}" @click="goEvent()">
      <img v-bind:src="getBannerImg()" v-bind:style="{position: 'absolute', top: '0px', left: `${($vssWidth - getBannerSize()[0])/2}px`, width: `${getBannerSize()[0]}`, height: `${getBannerSize()[1]}`}" v-bind:width="`${getBannerImg()[0]}px`">
    </div>-->
    <div class="page-header clear-filter" filter-color="black">
      <parallax class="page-header-image2" style="background-image:url('/img/img_main_home.png')"></parallax>
      <div class="container" id="top">
        <div class="d-flex flex-column justify-content-lg-around" style="margin-top: 0px;">
          <div class="brand">
            <img data-aos="fade-up" v-lazy="'/img/logo.png'" />
            <p class="h1"
                style="
                width: 340px;
                margin: -40px auto 0px;
              font-size: 20px;
              font-weight: 900;
              font-stretch: normal;
              font-style: normal;
              line-height: normal;
              text-align: right;
              text-shadow: 2px 2px #000000;
              color: #ffffff;
              ">for LINE Blockchain</p>
          </div>
          <div style="width: 100%; text-align: center; margin-top: -40px;">
            <!-- <img v-bind:src="getOpenImg()" width="446px" height="52px"> -->
          </div>          
          <!-- <div
            style="margin-top: 100px; margin-left: -15px; margin-right: -15px; height:100px; background-image: url('/img/bg_sale_deco.png'); background-size: cover; background-position: center center;"
          >
            <div data-aos="fade-right" class="col-lg-12" style="text-align: center; margin-top: 20px;">
              <h1
                class="h1"
                style="
              font-size: 2.4em;
              font-weight: 900;
              font-stretch: normal;
              font-style: normal;
              line-height: normal;
              text-align: center;
              text-shadow: 2px 2px #000000;
              color: #faca61;
              "
              >{{$t('Coming soon ln')}}</h1>
            </div>
          </div> -->
          <div style="margin-top: 60px;">
              <n-button
                @click="goGame()"
                class="btn btn-main3 btn-wide btn-upper btn-lg" style="height: 70px;"
              >{{$t('Game Start')}}</n-button>
            </div>
            <div style="margin: auto; margin-top: 0px; background-image: url(/img/btn_ios.png); background-size: 100% 100%;  width: 300px; height: 80px; padding-top: 20px; font-size: 1.4em !important;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -1.2px;
    text-align: center; cursor: pointer;" @click="goAppstore()">
              iOS App Store
            </div>
            <div style="margin: auto; margin-top: 0px; background-image: url(/img/btn_google.png); background-size: 100% 100%;  width: 300px; height: 80px; padding-top: 20px; font-size: 1.4em !important;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -1.2px;
    text-align: center; cursor: pointer;" @click="goPlaystore()">
              Google Play Store
            </div>
        </div>
      </div>
    </div>
    <!-- <trailer-section></trailer-section> -->
    <game-section></game-section>
    <blockchain-section></blockchain-section>
    <!-- <partners-section></partners-section> -->
  </div>
</template>
<script>
import { Parallax, Modal, Button } from "@/components";
import TrailerSection from "./components/TrailerSection";
import GameSection from "./components/GameSection";
import BlockchainSection from "./components/BlockchainSection";
import PartnersSection from "./components/PartnersSection";
import { Popover } from "element-ui";
import FlipCountdown from "./components/FlipCountdown";
import VueScreenSize from "vue-screen-size";
import config from "../config.js";
import axios from "axios";

export default {
  name: "index",
  bodyClass: "index-page",
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {
    [Button.name]: Button,
    [Popover.name]: Popover,
    Parallax,
    Modal,
    TrailerSection,
    GameSection,
    BlockchainSection,
    PartnersSection,
    FlipCountdown
  },
  computed: {
    deadtype() {
      if (this.isStarted) {
        console.log('pre-end')
        return "pre-end";
      }
      else {
        return "pre-start";
      }
    }
  },
  mounted: async function() {
    await this.loadLandSaleInfo(null, null);
    this.timerId = setInterval(async () => {
      await this.loadLandSaleInfo(null, true);
    }, 5 * 1000);
  },
  beforeDestroy: function() {
    if (this.timerId != null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  },
  methods: {
    loadLandSaleInfo: async function(zoneId, refresh) {
      let round = "pre2";
      let ret = await axios.post(`${config.api.nft_url}/presale/lands`, {
        round: round,
        zoneId: zoneId,
        refresh: refresh
      });

      console.log('ret - ', ret);

      this.isStarted = ret.data.isStarted;
      let products = ret.data.landSale.sale;
      let total = 0;
      let remain = 0;
      for (let i = 0; i < products.length; ++i) {
        let product = products[i];
        total += product.priceUSD * product.total;
        remain += product.priceUSD * product.remain;
      }
      if (total == 0) {
        this.rate = 0;
      }
      else {
        this.rate = (total - remain) / total;
      }      
    },
    goPre: async function() {
      let url = "//pre.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goGame: async function() {
      let url = "https://play-ln.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goAppstore: async function() {
      //alert('Coming soon');
      let url = "https://apps.apple.com/app/id1539371592"
      window.open(url, "_blank");
    },
    goPlaystore: async function() {
      //alert('Coming soon');
      let url = "https://play.google.com/store/apps/details?id=com.nodgames.lokln"
      window.open(url, "_blank");
    },
    goLand: async function() {
      let url = "//land.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goEvent() {
      let url = "//land.leagueofkingdoms.com/event" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    getBannerImg() {
      if (this.$i18n.locale == "ko") {
        return "/img/event/banner_event_kr.png";
      } else if (this.$i18n.locale == "ja") {
        return "/img/event/banner_event_jp.png";
      } else if (this.$i18n.locale == "ch-zn") {
        return "/img/event/banner_event_cn.png";
      } else {
        return "/img/event/banner_event_en.png";
      }
    },
    getOpenImg() {
      if (this.$i18n.locale == "ko") {
        return "/img/text_open_kr.png";
      } else if (this.$i18n.locale == "ja") {
        return "/img/text_open_jp.png";
      } else if (this.$i18n.locale == "ch-zn") {
        return "/img/text_open_cn.png";
      } else {
        return "/img/text_open_en.png";
      }
    },
    getBannerSize() {
      if (this.$vssWidth >= 700) {
        return [700, 80];
      }
      return [this.$vssWidth, (this.$vssWidth / 700) * 80];
    }
  },
  data: function() {
    return {
      isStarted: false,
      preurl: "//pre.leagueofkingdoms.com" + localStorage.urlParam,
      rate: 0
    };
  }
};
</script>
<style></style>
